/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type MineFontsQueryVariables = Exact<{
  organizationId?: string | null | undefined;
}>;

export type MineFontsQuery = {
  mineFonts: {
    fonts: Array<{
      fileName: string | null;
      fontId: string | null;
      status: boolean | null;
      name: string | null;
    } | null> | null;
  } | null;
};

export type CreateFontMutationVariables = Exact<{
  input?: Types.FontInput | null | undefined;
}>;

export type CreateFontMutation = {
  insertFont: { status: boolean | null } | null;
};

export const MineFontsDocument = gql`
  query mineFonts($organizationId: ID) {
    mineFonts(organizationId: $organizationId) {
      fonts {
        fileName
        fontId
        status
        name
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class MineFontsGQL extends Apollo.Query<
  MineFontsQuery,
  MineFontsQueryVariables
> {
  document = MineFontsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFontDocument = gql`
  mutation createFont($input: FontInput) {
    insertFont(font: $input) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateFontGQL extends Apollo.Mutation<
  CreateFontMutation,
  CreateFontMutationVariables
> {
  document = CreateFontDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
